<template lang="html">

  <section class="add">
    <h1>Add</h1>

    <contract-form :stageDefinitions="stageDefinitions" 
                   :statusDefinitions="statusDefinitions" 
                   :agreementTypes="agreementTypes" 
                   :restrictionTypes="restrictionTypes" 
                   :colleges="colleges">
    </contract-form>
  </section>

</template>

<script>
import ContractForm from "../../components/contracts/contract-form";
import contractApi from "../../api/contracts";
import collegeApi from "../../api/college";

export default {
  name: "add",
  props: [],
  mounted() {},
  data() {
    return {
      stageDefinitions: [],
      statusDefinitions: [],
      agreementTypes: [],
      restrictionTypes: [],
      colleges: []
    };
  },
  methods: {},
  computed: {},
  components: {
    "contract-form": ContractForm
  },
  created() {
    var that = this;
    contractApi
      .getContractStatusDefinitions()
      .then(function(response) {
        that.statusDefinitions = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    contractApi
      .getContractStageDefinitions()
      .then(function(response) {
        that.stageDefinitions = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    contractApi
      .getContractAgreementTypes()
      .then(function(response) {
        that.agreementTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    contractApi
      .getContractRestrictionTypes()
      .then(function(response) {
        that.restrictionTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    collegeApi.getCollegeList().then(function(response) {
      that.colleges = response.data;
    });
  }
};
</script>

<style scoped lang="scss">
</style>
